import { registerPlugin } from '@capacitor/core';
const Browser = registerPlugin('Browser', {
    web: () => import('./web').then(m => new m.BrowserWeb()),
});
export * from './definitions';
export { Browser };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@capacitor/browser/dist/esm/index.js
// module id = 645
// module chunks = 112